import React, {useContext, useState} from "react";
import BaseInstallment from "./BaseInstallment";
import CheckboxButton from "../../../components/CheckboxButton/CheckboxButton";
import ContactDialog from "../../../components/ContactDialog/ContactDialog";
import FormatUtils from "../../../utils/FormatUtils";
import analytics from "../../../utils/analytics";
import {CustomerTypeContext, isCustomerCompany} from "../../../context/customer-type-context";

const VAT_MULTIPLIER = 1.23;

function StaticInstallmentCalculator(props) {

    const promo = props.offer.promotionalOffer;
    const customerContext = useContext(CustomerTypeContext);
    const isCompany = isCustomerCompany(customerContext);
    const priceSuffix = isCompany ? "netto" : "brutto";

    const toGross = (netValue) => netValue == null ? null : netValue * VAT_MULTIPLIER;
    const toDisplayValue = (netValue) => netValue == null ? null : (isCompany ? netValue : toGross(netValue));

    const [isOpenContactDialog, setIsOpenContactDialog] = useState(false);


    const [ocAcChecked, setOcAcChecked] = useState(false);
    const [gapChecked, setGapChecked] = useState(false);

    const totalNet = promo.installmentNet
        + (promo.benefitsPackageNet != null ? promo.benefitsPackageNet : 0)
        + (ocAcChecked && promo.ocAcInsuranceNet != null ? promo.ocAcInsuranceNet : 0)
        + (gapChecked && promo.gapInsuranceNet != null ? promo.gapInsuranceNet : 0);

    const formattedTotal = FormatUtils.formatMoney(toDisplayValue(totalNet));
    const digitCount = (formattedTotal.match(/\d/g) || []).length;
    const totalAmountClass = "calc__rata-amount" + (digitCount >= 5 ? " calc__rata-amount--long" : "");
    const totalAmountNumber = formattedTotal.replace(/\s*zł\s*$/i, '');

    const contactClickHandler = () => {
        setIsOpenContactDialog(true);
        analytics.sendEvent({category: 'Zapytaj', action: 'Klikniecie', label: 'Kliknieto w Zapytaj', value: 1});
    };

    const reservationClickHandler = () => {
        analytics.sendEvent({category: 'Zarezerwuj', action: 'Klikniecie', label: 'Kliknieto w Zarezerwuj', value: 1});

        let calculationOffer = {
            vehicle: props.offer,
            financingCompany: promo.financingCompany,
            calculation: {
                customerType: customerContext[0],
                vehicleValueNet: props.offer.minimumPriceNet,
                vehicleValueGross: props.offer.minimumPriceGross,
                buyoutValueNet: promo.buyoutValueNet,
                buyoutValueGross: toGross(promo.buyoutValueNet),
                initialFeeValueNet: promo.initialFeeNet,
                initialFeeValueGross: toGross(promo.initialFeeNet),
                installmentNet: totalNet,
                installmentGross: toGross(totalNet),
                contractLength: promo.contractLengthMonths,
                installmentWithoutInsurance: promo.installmentNet,
                insuranceLength: 0,
                ocAcInsuranceInstallment: 0,
                gapInstallment: 0,
                ocAcInsuranceChecked: ocAcChecked,
                ocAcInsuranceData: ocAcChecked
                    ? {companyInsurance: promo.ocAcInsuranceNet, consumerInsurance: toGross(promo.ocAcInsuranceNet)} : null,
                gapChecked: gapChecked,
                gapData: gapChecked
                    ? {oneTimePremium: promo.gapInsuranceNet} : null,
                drivePlusInstallmentNet: promo.benefitsPackageNet,
                drivePlusInstallmentGross: toGross(promo.benefitsPackageNet)
            }
        };

        props.onShowOrderClick(true, calculationOffer);
    };

    return (
        <div className="calc__wrapper">
            <div className="calc__content">
                <BaseInstallment offer={props.offer} onBannerClick={contactClickHandler}/>

                <div className="calc__form-item">
                    <div className="calc__period-header">
                        <span className="calc__period-title">Okres leasingu</span>
                        <span className="calc__period-subtitle">(ilość miesięcznych rat)</span>
                    </div>
                    <div className="calc__static-value-box">{promo.contractLengthMonths} miesięcy</div>
                </div>

                <div className="calc__form-item">
                    <div className="calc__fee-header">
                        <p className="calc__form-label">Opłata wstępna</p>
                    </div>
                    <div className="calc__static-value-box">
                        {FormatUtils.formatMoney(toDisplayValue(promo.initialFeeNet))} <span className="calc__fee-unit">{priceSuffix}</span>
                    </div>
                </div>

                <div className="calc__form-item">
                    <div className="calc__fee-header">
                        <p className="calc__form-label">Wykup końcowy</p>
                    </div>
                    <div className="calc__static-value-box">
                        {FormatUtils.formatMoney(toDisplayValue(promo.buyoutValueNet))} <span className="calc__fee-unit">{priceSuffix}</span>
                    </div>
                </div>

                {promo.benefitsPackageNet != null && (
                    <div className="calc__form-item">
                        <CheckboxButton
                            title="Pakiet korzyści"
                            checked={true}
                            disabled={true}
                            label={FormatUtils.formatMoney(toDisplayValue(promo.benefitsPackageNet)) + "/mies."}
                        />
                    </div>
                )}
                {promo.ocAcInsuranceNet != null && (
                    <div className="calc__form-item">
                        <CheckboxButton
                            title="Ubezpieczenie OC/AC"
                            checked={ocAcChecked}
                            onChange={() => setOcAcChecked(prev => !prev)}
                            label={FormatUtils.formatMoney(toDisplayValue(promo.ocAcInsuranceNet)) + "/mies."}
                        />
                    </div>
                )}
                {promo.gapInsuranceNet != null && (
                    <div className="calc__form-item">
                        <CheckboxButton
                            title="GAP na czas trwania umowy"
                            checked={gapChecked}
                            onChange={() => setGapChecked(prev => !prev)}
                            label={FormatUtils.formatMoney(toDisplayValue(promo.gapInsuranceNet)) + "/mies."}
                        />
                    </div>
                )}

                <p className="calc__insurance-disclaimer">*Składka ma charakter poglądowy i może ulec zmianie.</p>
            </div>

            <div className="calc__summary">
                <div className="calc__submit">
                    <div className="calc__rata-box">
                        <span className="calc__rata-label">Rata razem</span>
                        <div className="calc__rata-value">
                            <span className={totalAmountClass}>{totalAmountNumber}<span className="calc__rata-currency">&nbsp;zł</span></span>
                            <span className="calc__rata-unit">{priceSuffix} / miesiąc</span>
                        </div>
                    </div>
                    <div className="calc__cta-row">
                        <button type="button" className="calc__btn calc__btn--contact" onClick={contactClickHandler}>
                            Skontaktuj się
                        </button>
                        <button type="button" className="calc__btn calc__btn--reserve" onClick={reservationClickHandler}>
                            Złóż wniosek
                        </button>
                    </div>
                </div>
            </div>

            <ContactDialog isOpen={isOpenContactDialog}
                           onClose={() => setIsOpenContactDialog(false)}
                           additionalMessage={"Dotyczy oferty: " + window.location.href}
            />
        </div>
    );
}

export default StaticInstallmentCalculator;
